import React from 'react';
import { Grid, Skeleton } from 'housecall-ui';

const skeletonItems = [0, 1, 2, 3];

export const TimeSlotsSkeleton = () => {
  return (
    <Grid container spacing={2} data-testid="TimeSlotsSkeleton__container">
      {skeletonItems.map((key) => (
        <Grid key={key} item md={4} xs={6}>
          <Skeleton variant="rect" height={56} aria-label="Loading" role="status" aria-live="polite" />
        </Grid>
      ))}
    </Grid>
  );
};
